<template>
  <my-giving-layout>
    <TithingMsg />
  </my-giving-layout>
</template>

<script>
import MasterLayout from '@/components/MasterLayout.vue';
import TithingMsg from './tithing-message.vue';
import MyGivingLayout from '@/components/MyGivingLayout.vue';

export default {
  components: { MasterLayout, TithingMsg, MyGivingLayout },
};
</script>
